<template>
    <main>
        <vs-table :data="data">
            <template #thead>
                <vs-th>#</vs-th>
                <vs-th>Tipe Pengajuan</vs-th>
                <vs-th>Jumlah Pengajuan Dana</vs-th>
                <vs-th>Status</vs-th>
                <vs-th>Tanggal Pengajuan</vs-th>
                <vs-th>#</vs-th>
            </template>
            <template v-slot="{data}">
                <vs-tr
                    v-for="(item, i) in data"
                    :key="i"
                >
                    <vs-td>
                        <i v-if="item.data_manfaat && item.data_manfaat.name === null">
                            {{ item.status_identity == 1 ? 'Campaign' : 'Layanan SOS' }} tidak ada.
                        </i>
                        <strong v-else>
                            {{ item.data_manfaat.name }}
                        </strong>
                    </vs-td>
                    <vs-td>
                        <vs-chip>
                            {{ item.status_identity == 1 ? 'Campaign' : 'Layanan SOS' }}
                        </vs-chip>
                    </vs-td>
                    <vs-td>
                        <strong>Rp {{ formatRupiah(item.jumlah_kebutuhan)}}</strong>
                    </vs-td>
                    <vs-td>
                        <strong v-if="item.status_aproval == 1" class="text-success">Disetujui</strong>
                        <strong v-else><strong class="text-danger">Belum Disetujui</strong></strong>
                    </vs-td>
                    <vs-td>
                        {{ modifyDate(item.created_at) }}
                    </vs-td>
                    <vs-td>
                        <a href="#" @click.prevent="showDetail(item)">
                            <small>
                            <feather-icon icon="EyeIcon">
                            </feather-icon>
                            </small>
                        </a>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <!-- Modal -->
        <vs-popup class="modal"  title="" :active.sync="popupActive">
            <h3 class="mb-4">
                <i v-if="manfaat.data_manfaat && manfaat.data_manfaat.name === null">
                    {{ manfaat.status_identity == 1 ? 'Campaign' : 'Layanan SOS' }} tidak ada.
                </i>
                <strong v-else>
                    {{ manfaat.data_manfaat.name }}
                </strong>
            </h3>
            <p class="mb-2">Tanggal Pengajuan</p>
            <p class="mb-6">
                {{ modifyDate(manfaat.created_at) }}
            </p>
            <div class="flex justify-between mb-6">
                <div>
                    <p class="mb-2">Jumlah Pengajuan</p>
                    <p class="mb-2">
                        {{ formatRupiah(manfaat.jumlah_kebutuhan) }}
                    </p>
                    <div v-if="manfaat.status_aproval == 1">
                        <p class="mb-2">Jumlah yang disetujui</p>
                        <p>
                            {{ formatRupiah(manfaat.acc_kebutuhan) }}
                        </p>
                    </div>
                </div>
                <div>
                    <p class="mb-2">Status</p>
                    <p>
                        <vs-chip :color="manfaat.status_aproval == 1 ? 'primary' : 'danger'">
                            {{ manfaat.status_aproval == 1 ? 'Disetujui' : 'Belum Disetujui' }}
                        </vs-chip>
                    </p>
                </div>      
            </div>
            <p class="mb-2">Deskripsi</p>
            <p>
                {{ manfaat.deskripsi_kebutuhan }}
            </p>
            
        </vs-popup>
        <!-- / -->
    </main>
</template>
<script>
import { mapState } from 'vuex'
export default {
    data: () => ({
        data: [],
        popupActive: false,
        manfaat: {
            created_at: '2022-04-10T08:18:01.000000Z',
            status_aproval: 1,
            status_identity: 1,
            jumlah_kebutuhan: 0,
            acc_kebutuhan: 0,
            data_manfaat: {name: null}
        }
    }),
    computed: {
        ...mapState('auth', ['profile'])
    },
    methods: {
        showDetail(item) {
            Object.assign(this.manfaat, item)
            this.popupActive = true
        },
        modifyDate(date) {
            // date format =>  2022-03-30T01:52:14.000000Z 
            const chunk00Z = date.split('.'),
                chunkT = chunk00Z[0].split('T')

            return chunkT.join(' ')
        }
    },
    created() {
        if(this.profile) {
            this.$vs.loading()
            this.$store.dispatch('campaign/getPM', {
                user_id: this.profile.id,
                ord: 'desc'
            })
            .then(datas => {
                this.$vs.loading.close()
                this.data = datas
            })
            .catch(e => {
                this.$vs.loading.close()
                this.showError(e)
            })
        }
        else {
            this.data = []
        }
        
    }
}
</script>